import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaNumberDefinition } from './TypedDefinition'

export const SchemaNumberPlugin = createSchemaPlugin(
  'Schema.Number',
  SchemaNumberDefinition
)
